export const naac_data=[
    // {
    //     'id':3,
    //     'program':'Policy for Promotion of Research',
    //     'pdf':'https://drive.google.com/file/d/1HqGMXqR73D7ip0Qk_ZWH-89RS8DMgHMH/view?usp=sharing',
    // },
    {
        'id':2,
        'program':'NAAC Committee Members AY 2023-25',
        'pdf':'https://drive.google.com/file/d/1s9kwnaP-XOg_KIbGmCPYLpbwaFAq1ycf/view?usp=sharing',
    },
    {
        'id':1,
        'program':'SSR 2019',
        'pdf':'https://drive.google.com/file/d/16mZkLmHrTUkolXDtJS8mQLO3GAcgXuhC/view?usp=sharing',
    },
    {
        'id':'3',
        'program':'Extension of Validity',
        'pdf':'https://drive.google.com/file/d/1OUVIYp9RofeAPkI9rNVfR4WWZ2uEQLZp/view?usp=sharing'
    },
]
export const naac_menu=[
   
    {
        id: "1",
        path: "/naac",
        link: "About",
        arl: "l",
    } ,
    {
        id: "2",
        path: "/naacbestpractices",
        link: "Best Practices",
        arl: "l",
    }
]
export const naac=[
    {
        'id':'1',
        'program':'Description of the practices',
        'pdf':'https://drive.google.com/file/d/1erUyCkfjZs7g7ie_CSOrLRi5SF6WsT14/view?usp=drive_link'
    },
    {
        'id':'2',
        'program':'Evidence of the practices',
        'pdf':'https://drive.google.com/file/d/16IjZIr5J_vjK-zesT9cVK_AJSN7NQJWr/view?usp=sharing'
    },
    
]
export const naac_best=[
    {
        'id':'1',
        'program':'2023-2024',
        'click':'/naacbest2324'
        }
]